"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("./component");
const Editor_1 = require("./Editor");
const Interface_1 = require("./Interface");
require("./Player.scss");
const browser_fs_access_1 = require("browser-fs-access");
const fileLoader_1 = require("../utils/fileLoader");
const Audio_1 = require("./Audio");
const utils_1 = require("@sfz-tools/core/dist/utils");
const api_1 = require("@sfz-tools/core/dist/api");
class Player extends component_1.default {
    constructor(id, options) {
        var _a;
        super('player');
        this.loader = new fileLoader_1.default();
        if (options.audio)
            this.setupAudio(options.audio);
        if (options.header)
            this.setupHeader(options.header);
        if (options.interface)
            this.setupInterface(options.interface);
        if (options.editor)
            this.setupEditor(options.editor);
        (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.appendChild(this.getEl());
        if (options.instrument) {
            this.loadRemoteInstrument(options.instrument);
        }
    }
    setupAudio(options) {
        options.loader = this.loader;
        this.audio = new Audio_1.default(options);
        this.audio.addEvent('change', (event) => {
            if (this.interface)
                this.interface.setKeyboard(event.data);
        });
        this.audio.addEvent('keyboardMap', (event) => {
            if (this.interface)
                this.interface.setKeyboardMap(event.data);
        });
        this.audio.addEvent('preload', (event) => {
            if (this.interface)
                this.interface.setLoadingText(event.data.status);
        });
        this.audio.addEvent('loading', (event) => {
            if (this.interface)
                this.interface.setLoadingState(event.data);
        });
    }
    setupInterface(options) {
        options.loader = this.loader;
        this.interface = new Interface_1.default(options);
        this.interface.addEvent('change', (event) => {
            if (this.audio)
                this.audio.update(event.data);
        });
        this.getEl().appendChild(this.interface.getEl());
        this.interface.setLoadingState(true);
    }
    setupEditor(options) {
        options.loader = this.loader;
        this.editor = new Editor_1.default(options);
        this.getEl().appendChild(this.editor.getEl());
    }
    setupHeader(options) {
        const div = document.createElement('div');
        div.className = 'header';
        if (options.local) {
            const inputLocal = document.createElement('input');
            inputLocal.type = 'button';
            inputLocal.value = 'Local directory';
            inputLocal.addEventListener('click', (e) => __awaiter(this, void 0, void 0, function* () {
                yield this.loadLocalInstrument();
            }));
            div.appendChild(inputLocal);
        }
        if (options.remote) {
            const inputRemote = document.createElement('input');
            inputRemote.type = 'button';
            inputRemote.value = 'Remote directory';
            inputRemote.addEventListener('click', (e) => __awaiter(this, void 0, void 0, function* () {
                const id = window.prompt('Enter a GitHub owner/repo', 'studiorack/black-and-green-guitars');
                if (id)
                    yield this.loadRemoteInstrument({
                        branch: 'compact',
                        id,
                        name: 'Custom',
                    });
            }));
            div.appendChild(inputRemote);
        }
        if (options.presets) {
            const inputPresets = document.createElement('select');
            options.presets.forEach((preset) => {
                const inputOption = document.createElement('option');
                inputOption.innerHTML = preset.name;
                if (preset.selected)
                    inputOption.selected = true;
                inputPresets.appendChild(inputOption);
            });
            inputPresets.addEventListener('change', (e) => __awaiter(this, void 0, void 0, function* () {
                const preset = options.presets[inputPresets.selectedIndex];
                yield this.loadRemoteInstrument(preset);
            }));
            div.appendChild(inputPresets);
        }
        this.getEl().appendChild(div);
    }
    loadLocalInstrument() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const blobs = (yield (0, browser_fs_access_1.directoryOpen)({
                    recursive: true,
                }));
                console.log(`${blobs.length} files selected.`);
                this.loadDirectory((0, utils_1.pathGetRoot)(blobs[0].webkitRelativePath), blobs);
            }
            catch (err) {
                if (err.name !== 'AbortError') {
                    return console.error(err);
                }
                console.log('The user aborted a request.');
            }
        });
    }
    loadRemoteInstrument(preset) {
        return __awaiter(this, void 0, void 0, function* () {
            const branch = preset.branch || 'compact';
            const response = yield (0, api_1.apiJson)(`https://api.github.com/repos/${preset.id}/git/trees/${branch}?recursive=1`);
            const paths = response.tree.map((file) => `https://raw.githubusercontent.com/${preset.id}/${branch}/${file.path}`);
            yield this.loadDirectory(`https://raw.githubusercontent.com/${preset.id}/${branch}/`, paths);
        });
    }
    loadDirectory(root, files) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let audioFile;
            let audioFileDepth = 1000;
            let audioFileJson;
            let audioFileJsonDepth = 1000;
            let interfaceFile;
            let interfaceFileDepth = 1000;
            for (const file of files) {
                const path = typeof file === 'string' ? file : file.webkitRelativePath;
                const depth = ((_a = path.match(/\//g)) === null || _a === void 0 ? void 0 : _a.length) || 0;
                if ((0, utils_1.pathGetExt)(path) === 'sfz' && depth < audioFileDepth) {
                    audioFile = file;
                    audioFileDepth = depth;
                }
                if (path.endsWith('.sfz.json') && depth < audioFileJsonDepth) {
                    audioFileJson = file;
                    audioFileJsonDepth = depth;
                }
                if ((0, utils_1.pathGetExt)(path) === 'xml' && depth < interfaceFileDepth) {
                    interfaceFile = file;
                    interfaceFileDepth = depth;
                }
            }
            console.log('audioFile', audioFile);
            console.log('audioFileJson', audioFileJson);
            console.log('interfaceFile', interfaceFile);
            this.loader.resetFiles();
            this.loader.setRoot(root);
            this.loader.addDirectory(files);
            if (this.interface) {
                if (interfaceFile) {
                    const file = this.interface.loader.addFile(interfaceFile);
                    yield this.interface.showFile(file);
                    this.interface.render();
                }
                else {
                    this.interface.reset();
                }
            }
            if (this.editor) {
                const defaultFile = audioFile || interfaceFile;
                if (defaultFile) {
                    const file = this.editor.loader.addFile(defaultFile);
                    yield this.editor.showFile(file);
                    this.editor.render();
                }
                else {
                    this.editor.reset();
                }
            }
            if (this.audio) {
                const audioFilePriority = audioFileJson || audioFile;
                if (audioFilePriority) {
                    const file = this.audio.loader.addFile(audioFilePriority);
                    yield this.audio.showFile(file);
                }
                else {
                    this.audio.reset();
                }
            }
        });
    }
}
exports.default = Player;
